import Icon from '../components/Icon';

const Grid = Icon(
  'grid',
  <>
    <path
      fillRule="evenodd"
      d="M4 2.25A1.75 1.75 0 0 0 2.25 4v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 10.75 9V4A1.75 1.75 0 0 0 9 2.25zM3.75 4A.25.25 0 0 1 4 3.75h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25H4A.25.25 0 0 1 3.75 9zM15 2.25A1.75 1.75 0 0 0 13.25 4v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 21.75 9V4A1.75 1.75 0 0 0 20 2.25zM14.75 4a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-5a.25.25 0 0 1-.25-.25zM13.25 15c0-.966.784-1.75 1.75-1.75h5c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 20 21.75h-5A1.75 1.75 0 0 1 13.25 20zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25zM4 13.25A1.75 1.75 0 0 0 2.25 15v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 10.75 20v-5A1.75 1.75 0 0 0 9 13.25zM3.75 15a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25z"
      clipRule="evenodd"
    />
  </>
);

export default Grid;
